import { Button } from 'antd'
import React from 'react'
import styles from './InsituPointPopup.module.scss'
import { DateFormat } from '../../../../generic/StaticVariable'
import moment from 'moment'

interface IInsituPointPopup {
    coordinates: number[]
    name: string
    source: string
    timePeriod: {
        startDate: string,
        endDate: string
    }
    createNewPoint: (coordinates: Array<number>) => void;
}

const InsituPointPopup: React.FC<IInsituPointPopup> = ({
    coordinates, name, source, timePeriod, createNewPoint
}) => {
    return (
        <div className={styles.container}>
            <div className={styles.title}><b>{name}</b></div>
            <div className={styles.coordinates}>
                <div>Long {Math.round(coordinates[0] * 10000) / 10000}</div>
                <div className={styles.leftPadding}>Lat {Math.round(coordinates[1] * 10000) / 10000}</div>
            </div>
            <div className={styles.source}>
                <div>Source: {source}</div>
            </div>
            <div>
                <div>
                    Time Period: {moment(timePeriod.startDate).format(DateFormat)} - {moment(timePeriod.endDate).format(DateFormat)}
                </div>
            </div>
            <div className={styles.buttonWrapper}>
                <Button onClick={() => createNewPoint(coordinates)} className={styles.button}>
                    New point in this location
                </Button>
            </div>
        </div>
    )
}

export default InsituPointPopup
